import api from './client'

export interface SatPlan {
  id: number
  plan_code: string
  name: string
  price_in_cent: number
  description: string | null
  is_active: boolean
  platform_type: string
}

export interface StripeConfig {
  publishable_key: string
  success: boolean
}

export interface PaymentIntentResponse {
  client_secret: string
  payment_intent_id: string
  amount: number
  currency: string
}

export const paymentApi = {
  getStripeConfig: () =>
    api.get<StripeConfig>('/payment/stripe-config'),

  getPlatformType: () =>
    api.get<{ platform_type: string }>('/platform/type'),

  getPublicPlans: () =>
    api.get<SatPlan[]>('/platform/plans'),

  getSatPlans: () =>
    api.get<SatPlan[]>('/payment/sat-plans'),

  createPaymentIntent: (data: { amount: number; currency?: string; description?: string; plan_code?: string }) =>
    api.post<PaymentIntentResponse>('/payment/create-payment-intent', data),

  confirmPayment: (data: { payment_intent_id: string; plan_code?: string }) =>
    api.post<{ success: boolean; message: string; new_token?: string }>('/payment/confirm-payment', data),
}
